import handleKeydownActions from 'foundation/js/utils/handleKeydownActions'
import tabNavigation from 'foundation/js/utils/tabNavigation'

const MENU_ITEM_CLASSNAME = 'be-js--menu-item'
const MENU_OVERLAY_CONTAINER_CLASSNAME = 'be-js--overlay-container'

export default function() {
    const menuItems = document.querySelectorAll(`.${MENU_ITEM_CLASSNAME}`)
    menuItems.forEach((menuItem) => menuItem.addEventListener('keydown', handleKeydown))
}

const handleKeydown = function(e) {
    const isContainer = e.target.closest(`.${MENU_OVERLAY_CONTAINER_CLASSNAME}`)

    if (isContainer) {
        handleKeydownInsideSubmenu(e)
    } else {
        handleKeydownInsideMenu(e)
    }
}

const handleKeydownInsideMenu = function(e) {
    const parentElm = document.querySelector('body')
    const tabProps = { 
        parentContainer: parentElm, 
        targetClassName: MENU_ITEM_CLASSNAME, 
        key: e.key
    }
    const tabNav = new tabNavigation(tabProps)

    handleKeydownActions(e, ['ArrowLeft'], () => tabNav.tabPrev())
    handleKeydownActions(e, ['ArrowRight'], () => tabNav.tabNext())
    handleKeydownActions(e, ['ArrowDown', 'Space', ' ', 'Enter'], () => navigateToSubmenu(e))
}

const navigateToSubmenu = function(e) {
    e.preventDefault()
    if (e.target.getAttribute('aria-haspopup') === 'true') { 
        e.target.click()
        const submenuId = e.target.dataset.targetMenu
        if (submenuId) {
            const submenu = document.getElementById(submenuId)
            const submenuItems = submenu?.querySelectorAll(`.${MENU_ITEM_CLASSNAME}`)
            if (submenuItems) {
                setTimeout(() => submenuItems[0].focus(), 50)
            }            
        }
    }
}

const handleKeydownInsideSubmenu = function(e) {
    const parentElm = e.currentTarget.closest(`.${MENU_OVERLAY_CONTAINER_CLASSNAME}`)
    const tabProps = { 
        parentContainer: parentElm, 
        targetClassName: MENU_ITEM_CLASSNAME, 
        key: e.key
    }
    const tabTraps = new tabNavigation(tabProps)
    handleKeydownActions(e, ['ArrowLeft', 'ArrowUp', 'ShiftTab'], () => tabTraps.tabTrapPrev(), true)
    handleKeydownActions(e, ['ArrowRight', 'ArrowDown', 'Tab'], () => tabTraps.tabTrapNext(), true)
}

